import type { OrganisationIntegrationSettingsLocales } from '../types';

const organisationIntegrationSettingsLocales: OrganisationIntegrationSettingsLocales =
  {
    authenticationSuccessful: 'Successvol geintegreerd',
    authenticationSuccessfulMessage:
      'De authenticatie is succesvol. Je kan nu opdrachten ophalen uit SDB om in Tadaah te zetten.',
    backToFetchJobs: 'Terug naar Opdrachten Ophalen',
    backToSettings: 'Terug naar Instellingen',
    break: 'Pauze',
    certificates: 'Certificaten (optioneel)',
    competence: 'Competentie',
    connectSDBInfoParagraph1: `Met de SDB integratie worden opdrachten opgehaald die vervolgens
                aangemaakt kunnen worden in Tadaah. Zo worden gaten nog sneller
                gevuld.`,
    connectSDBInfoParagraph2: `Om de integratie te gebruiken, heeft Tadaah een API key en de naam van het SDB account van de organisatie nodig. Dit moet geconfigureerd worden in het SDB platform. De informatie hiervoor is ook gedocumenteerd op het SDB platform. 

Doorloop de volgende stappen:
  1. Maak een API sleutel aan.
  2. Geef het "uitzendbureau" Tadaah toegang tot de API.
  3. Zet de opdrachten uit naar Tadaah.

Om een dienst uit te zetten naar Tadaah:
  1. Zet je eerst een dienst van de ballenbak in RoosterPlan uit naar flex (rechtermuisknop op dienst – Zet uit naar flex).
  2. Vervolgens ga je naar FlexPlan en accepteer je de aanvraag.
  3. Als laatste stap klik je met de rechtermuisknop op de aanvraag, klikt op “Flexmatch-instellingen” en selecteer je onderaan bij Extern - “UZB Tadaah” – Inschrijven/Koppelen en klik je op Opslaan).

Als je hulp nodig hebt bij deze stappen, neem dan contact op met de support afdeling van SDB.`,
    connectWith: 'Connect met %{provider}',
    createJob: 'Oproep Aanmaken',
    createJobs: 'Opdrachten aanmaken',
    date: 'Datum',
    end: 'Eind',
    fetchJobs: 'Opdrachten Ophalen',
    fetchJobsDescription:
      'Vul de filters in. Op basis van deze filters worden opdrachten opgehaad uit SDB.',
    foundJobs: 'Gevonden Opdrachten (%{count})',
    from: 'Vanaf',
    function: 'Functie',
    hideApiKey: 'Verberg API sleutel',
    integrations: 'integraties',
    jobCreated: 'Oproep Aangemaakt',
    jobIsCreatedMessage:
      'Oproep is aangemaakt in Tadaah. Bekijk de opdracht in de opdrachten sectie.',
    jobsFetchedFromSDB: 'Opdrachten opgehaald uit SDB',
    jobsFound: 'Opdrachten gevonden',
    location: 'Locatie',
    maxRate: 'Maximaal uurtarief (excl. BTW)',
    maxRateExempt: 'Maximaal uurtarief (vrijgesteld)',
    noJobsFound: 'Geen opdrachten gevonden.',
    noJobsFoundInDateRange:
      'Er zijn geen opdrachten gevonden binnen dit datumbereik.',
    organisationNotSelectedError:
      'Selecteer een organisatie in het Navigatie menu.',
    sdbIntegration: 'SDB Integratie',
    sdbIntegrationDescription:
      'Importeer opdrachten direct uit SDB. Dit is momenteel nog geen volledige integratie, maar je kunt wel met een druk op de knop opdrachten uit SDB importeren, en aanbieden via Tadaah.',
    sdbJobAlreadyExistsError: 'Deze opdracht uit SDB bestaat al in Tadaah.',
    sdbOrganisationAccount: 'SDB Organisatie Account',
    selectBreakTime: 'Vul het aantal minuten pauze in.',
    selectCertificatesMultiple: 'Selecteer certificaten (optioneel)',
    selectCompetence: 'Selecteer een competentie',
    selected: 'geselecteerd',
    selectedJobs: 'Geselecteerde Opdrachten (%{count})',
    selectJobs: 'Selecteer Opdrachten',
    selectLocation: 'Selecteer een locatie',
    selectMaxRate: 'Vul een bedrag (€) in.',
    showApiKey: 'Toon API sleutel',
    start: 'Start',
    title: 'Titel',
    to: 'Tot',
    updateIntegration: 'Integratie bijwerken',
  };

export default organisationIntegrationSettingsLocales;
